import React, { useEffect, useRef } from 'react';
import { Header, Footer } from '../components/HomePage';

// Public 404 for unmatched routes (Fix-first #1: a mistyped URL should not
// force a login). Plain text, no styling beyond what exists.
function NotFoundPage() {
  const headingRef = useRef(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <>
      <Header />
      <main style={{ padding: '2rem', textAlign: 'center' }}>
        <h1 ref={headingRef} tabIndex={-1}>Page not found</h1>
        <p>The page you're looking for doesn't exist.</p>
        <a href="/" style={{ display: 'inline-flex', alignItems: 'center', minHeight: '44px', padding: '12px 16px' }}>Go back home</a>
      </main>
      <Footer />
    </>
  );
}

export default NotFoundPage;
